import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Table } from "@mui/joy";
import LoadingBox from "../core/components/LoadingBox";
import { triggerLoadNotificacoes, triggerMarkRead, triggerVisualizarTodas } from "./NotificacoesSlice";
import { v4 as uuidv4 } from "uuid";
import { formatDateJavaComHoras, loadingValue } from "../helper/functions";
import Botao from "../core/components/Botao";
import { setLoadingFlag } from "../core/loading/LoadingSlice";

function NotificacoesDashboard() {

    var dispatch = useDispatch();
    var flags = useSelector(state => state.loading.flags)
    var lista = useSelector((state) => state.notificacoes.lista)
    // var loading = checkFlag(flags, "")
    var loading = loadingValue(flags, "NOT_TELA_DATA")


    React.useEffect(() => {
        dispatch(triggerLoadNotificacoes())
    }, []);

    if (loading) {
        return <Grid>
            <LoadingBox />
        </Grid>
    }

    const markRead = (id, localTag) => {
        dispatch(triggerMarkRead({
            id: id,
            tag: localTag
        }))
    }

    const visualizarTodas = () => {
        dispatch(triggerVisualizarTodas())
    }

    return <Grid container sx={{ padding: "10px" }}>
        <Grid xs={12} sx={{pb: 1}}>
            <Button onClick={visualizarTodas}>Marcar todas visualizadas</Button>
        </Grid>
        <Grid xs={12}>
        <Table size="small" aria-label="striped table" stripe={"odd"}>
            <thead>
                <tr>
                    <th style={{ width: "15%", textAlign: "left" }}>Data</th>
                    <th style={{ width: "25%", textAlign: "left" }}>Service</th>
                    <th style={{ width: "54%", textAlign: "left" }}>Titulo</th>
                    <th style={{ textAlign: "left" }}>Read</th>
                </tr>
            </thead>
            <tbody>
                {lista.map(l => {
                    var localTag = "NOT_ITEM_" + l.id;
                    var localLoading = loadingValue(flags, localTag)
                    return <tr key={l.id}>
                        <td>{formatDateJavaComHoras(l.occurredAt)}</td>
                        <td>{l.service}</td>
                        <td><pre>{l.titulo} <br/>{l.mensagem}</pre></td>
                        <td>
                            <Botao size="sm" color="danger" text="Read"
                            loading={localLoading} 
                            onClick={() => markRead(l.id, localTag)}
                            hidden={l.seenAt != null}/>
                        </td>
                    </tr>})}

            </tbody>
        </Table>
        </Grid>
    </Grid>
}

export default NotificacoesDashboard;